export { default } from './TraitsTableManager';
